import { action, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import React, { PropTypes } from 'react';
import Form, { DateInput, FormActions, FormBody, SelectInput, SwitchInput } from '../../Form';
import FormMultiSelectInput from '../../FormMultiSelectInput';
import { analysis as api, reportingTemplate } from '../../../actions/api';
import { reportGenerator } from './reportGenerator';
import Spinner from '../../Spinner';
import DataTable from '../../DataTable';
import { getDisplayDate } from '../../../libs/date';
import _ from 'lodash';
import { BASE_URL } from '../../../config';

@inject('stationStore', 'reportingTemplateStore', 'stationTypeStore', 'locationStore', 'locationTypeStore', 'reportingTemplateHeaderStore')
@observer
class ReportGenerate extends React.Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }

  @observable multiStationOptions = [];
  @observable filters = {
    report_template_id: null,
    date_from: moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'),
    date_to: moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss'),
    latest: false,
    filter_by_location: false,
    location_id: null,
    location_type_id: null,
  }
  @observable report = '';
  @observable splitReport = [];
  @observable isLoading = false;
  @observable includeGraph = false;
  @observable splitByStation = false;
  state = {
    raw_observations: null,
    report_observations: null,
    sortingColumnId: '',
    sort_order: '',
  };

  componentWillMount() {
    const { stationStore, reportingTemplateStore, stationTypeStore, locationStore, locationTypeStore, reportingTemplateHeaderStore } = this.props;
    if (!stationStore.items.length && !stationStore.isLoading) stationStore.fetchItems();
    if (!reportingTemplateStore.items.length && !reportingTemplateStore.isLoading) reportingTemplateStore.fetchItems();
    if (!stationTypeStore.items.length && !stationTypeStore.isLoading) stationTypeStore.fetchItems();
    if (!locationStore.items.length && !locationStore.isLoading) locationStore.fetchItems();
    if (!locationTypeStore.items.length && !locationTypeStore.isLoading) locationTypeStore.fetchItems();
    if (!reportingTemplateHeaderStore.items.length && !reportingTemplateHeaderStore.isLoading) reportingTemplateHeaderStore.fetchItems();
    this.populateOptions();
  }

  populateOptions = () => {
    const { stationStore } = this.props;
    if (stationStore.items.length === 0) {
      setTimeout(() => {
        this.populateOptions();
      }, 300)
    } else {
      if (process.env.NODE_ENV !== 'production' && false) {
        // view oracle
        this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, tags: item.tags, value: [29].indexOf(item.id) > -1 }));
        this.filters.report_template_id = 9;
        this.onView();
      } else {
        this.multiStationOptions = stationStore.items.map(item => ({ id: item.id, name: item.name, label: item.name, value: false, tags: item.tags }));
      }
    }
  };

  @action onOptionClicked = item => item.value = !item.value;
  @action onChangeFilters = (key, e) => {
    const { reportingTemplateStore } = this.props;
    this.filters[key] = e.target.value;
    this.report = '';

    let sort = reportingTemplateStore.items && reportingTemplateStore.items.find(item => item.id == this.filters.report_template_id)
    let sortingOrder = sort && sort.sort_order
    let sortingColumnId = sort && sort.sort_by && sort.columns && sort.columns.find(item => item.label == sort.sort_by).id

    this.setState({
      sort_order: sortingOrder == 0 ? 'asc' : 'desc',
      sortingColumnId: sortingColumnId 
    });
  }

  handleSortingColumnChange = (e) => {
    const selectedColumnLabel = e.target.value;
    this.setState({ sortingColumnId: selectedColumnLabel });
  }

  handleSortOrderChange = (e, field) => {
    e.preventDefault()
    this.setState({ sort_order: field })
  }

  dataSort = (data, sortingColumnId, sort_order) => {
    if (data === null || data.length === 0) {
      return [];
    }
    const { reportingTemplateStore } = this.props;
    const { report_template_id } = this.filters;

    const template = reportingTemplateStore.findById(report_template_id);
    const matchingColumn = template.columns.find((column) => column.id === sortingColumnId)
    const matchingColumnName = matchingColumn ? matchingColumn.label : '';

    const isNumericColumn = !isNaN(parseFloat(data[0][matchingColumnName])) && isFinite(data[0][matchingColumnName]);
    // const dateLabel = template.columns.find((item) => item.label === matchingColumnName && item.type === 6);

    if (!!matchingColumn && matchingColumn.type === 6) {
      data.sort((a, b) => {
        const dateA = moment(a[matchingColumn.label]);
        const dateB = moment(b[matchingColumn.label]);

        if (sort_order == "asc") {
          return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
        } else if (sort_order == "desc") {
          return dateB.isBefore(dateA) ? -1 : dateB.isAfter(dateA) ? 1 : 0;
        } return dateB.isBefore(dateA) ? -1 : dateB.isAfter(dateA) ? 1 : 0;

      });
    } else {
      data.sort((a, b) => {
        const aValue = a[matchingColumnName];
        const bValue = b[matchingColumnName];

        const normalizeValue = (value) => (value === '-' ? "-100" : value || '');

        const aValueForComparison = normalizeValue(aValue);
        const bValueForComparison = normalizeValue(bValue);

        if (sort_order == "asc") {
          return isNumericColumn
            ? parseFloat(aValueForComparison) - parseFloat(bValueForComparison)
            : aValueForComparison.localeCompare(bValueForComparison);
        } else if (sort_order == "desc") {
          return isNumericColumn
            ? parseFloat(bValueForComparison) - parseFloat(aValueForComparison)
            : bValueForComparison.localeCompare(aValueForComparison);
        }

        return isNumericColumn
          ? parseFloat(bValueForComparison) - parseFloat(aValueForComparison)
          : bValueForComparison.localeCompare(aValueForComparison);

      });
    }
    return data
  }

  onView = e => {
    !!e && e.preventDefault();

    const { stationStore, reportingTemplateStore, stationTypeStore, locationStore } = this.props;
    const { date_from, date_to, report_template_id, latest, filter_by_location, location_id } = this.filters;

    let stations = [];

    if (!report_template_id) {
      this.context.notify.error({ message: 'Select template.' });
      return;
    }

    if (filter_by_location) {
      if (!location_id) {
        this.context.notify.error({ message: 'Select location.' });
        return;
      }
      stations = stationStore.items.reduce((list, item) => {
        if (locationStore.isPartOf(item.location_id, location_id)) list.push(item.id);
        return list;
      }, []);
    } else {
      stations = this.multiStationOptions.reduce((list, item) => {
        if (item.value) list.push(item.id);
        return list;
      }, []);
    }

    if (!stations.length) {
      this.context.notify.error({ message: 'No stations.' });
      return;
    }

    this.isLoading = true;
    this.report = '';

    const template = reportingTemplateStore.findById(this.filters.report_template_id);
    const { parameters, offset } = template.columns.reduce((acc, item) => {
      if (+item.type === 3) {
        if (acc.parameters.indexOf(+item.key) === -1) acc.parameters.push(+item.key);
        if (!!item.agg_period && !!item.agg_method && !!item.agg_offset) acc.offset = +item.agg_offset > +acc.offset ? +item.agg_offset : +item.offset; // get highest offset
      }
      return acc;
    }, { parameters: [], offset: 0 });
    api.fetchMore({
      stations,
      parameters,
      date_from: latest ? moment(date_to).format('YYYY-MM-DDTHH:mm:ss') : moment(date_from).format('YYYY-MM-DDTHH:mm:ss'),
      date_to: moment(date_to).format('YYYY-MM-DDTHH:mm:ss'),
      returnMetaData: 'true'
    }).then(async res => {
      this.isLoading = false;
      const { report, observations } = await reportGenerator(res, reportingTemplateStore.findById(report_template_id), { stationTypeStore, locationStore });
      this.report = report;
      this.setState({
        raw_observations: res.map(item => {
          item.location = !!item.location_id ? locationStore.getFullLocation(locationStore.findById(item.location_id)) : '';
          return item;
        }),
        report_observations: observations,
      });
      this.splitReport = await Promise.all(
        res.map(async station => {
          return reportGenerator([station], reportingTemplateStore.findById(report_template_id), { stationTypeStore, locationStore });
        })
      );
    }).catch(err => {
      this.isLoading = false;
      console.log(err);
      this.context.notify.error({ message: err.toString() });
    });
  }

  _onDownload = async (report, raw_observations, report_observations) => {
    if (!report || !raw_observations || !report_observations) {
      return;
    }
    const { reportingTemplateStore } = this.props;
    let template = reportingTemplateStore.findById(this.filters.report_template_id)
    const stationNameLabel = template.columns.find(item => item.type === 2 && item.key === -1);
    const dateLabel = template.columns.find(item => item.type === 6);
    const snLabel = template.columns.find(item => item.type === 1);

    let lines = report.split('\n');
    let headers = lines.shift().split(',');

    let data = lines.map((line) => line.split(',').reduce((acc, field, index) => Object.assign(acc, { [headers[index]]: field }), {}))

    if (!!this.state.sortingColumnId && !!this.state.sort_order) {
      data = this.dataSort(data, this.state.sortingColumnId, this.state.sort_order);
    } else {
      if (stationNameLabel && dateLabel)
        data.sort((a, b) => a[stationNameLabel.label].localeCompare(b[stationNameLabel.label]) || b[dateLabel.label].localeCompare(a[dateLabel.label]));
      else if (stationNameLabel)
        data.sort((a, b) => a[stationNameLabel.label].localeCompare(b[stationNameLabel.label]));
      else if (dateLabel)
        data.sort((a, b) => b[dateLabel.label].localeCompare(a[dateLabel.label]));
    }

    let csv = [headers.toString()]
    data.forEach((item, index) => {
      let toPush = [];
      headers.forEach((header) => {
        if (snLabel && header === snLabel.label) return toPush.push(index + 1)
        else toPush.push(item[header])
      })
      csv.push(toPush.join(','))
    });
    const chart = this.includeGraph ? await this.getChartSvg(raw_observations, report_observations) : null;
    reportingTemplateStore.downloadReport(csv.join('\n'), template.format, { report_name: template.description, orientation: template.orientation, date_from: this.filters.date_from, date_to: this.filters.date_to, chart, station: this.splitByStation ? raw_observations[0] : null, header_id: template.header_id });
  }

  onDownload = e => {
    e.preventDefault();
    if (this.splitByStation) {
      this.splitReport.forEach((item, i) => this._onDownload(item.report, [this.state.raw_observations[i]], item.observations));
    } else {
      this._onDownload(this.report, this.state.raw_observations, this.state.report_observations);
    }
  }

  sendMail = e => {
    e.preventDefault();

    const { stationStore, reportingTemplateStore, stationTypeStore, locationStore } = this.props;
    const { date_from, date_to, report_template_id, latest, filter_by_location, location_id } = this.filters;

    let stations = [];

    if (!report_template_id) {
      this.context.notify.error({ message: 'Select template.' });
      return;
    }

    if (filter_by_location) {
      if (!location_id) {
        this.context.notify.error({ message: 'Select location.' });
        return;
      }
      stations = stationStore.items.reduce((list, item) => {
        if (locationStore.isPartOf(item.location_id, location_id)) list.push(item.id);
        return list;
      }, []);
    } else {
      stations = this.multiStationOptions.reduce((list, item) => {
        if (item.value) list.push(item.id);
        return list;
      }, []);
    }

    if (!stations.length) {
      this.context.notify.error({ message: 'No stations.' });
      return;
    }

    const template = reportingTemplateStore.findById(this.filters.report_template_id);
    const { parameters, offset } = template.columns.reduce((acc, item) => {
      if (+item.type === 3) {
        if (acc.parameters.indexOf(+item.key) === -1) acc.parameters.push(+item.key);
        if (!!item.agg_period && !!item.agg_method && !!item.agg_offset) acc.offset = +item.agg_offset > +acc.offset ? +item.agg_offset : +item.offset; // get highest offset
      }
      return acc;
    }, { parameters: [], offset: 0 });

    reportingTemplate.report.generate(report_template_id, { stations: stations.join(','), parameters: parameters.join(','), date_from, date_to })
      .then((res) => {
        this.context.notify.success(res);
      });
  }

  _renderReport = report => {
    const template = this.props.reportingTemplateStore.findById(this.filters.report_template_id);

    let lines = report.split('\n');
    let headers = lines.shift().split(',');
    let columns = headers.map(item => ({ key: item, label: item }));
    let data = lines.map((line) => line.split(',').reduce((acc, field, index) => Object.assign(acc, { [headers[index]]: field }), {}))

    if (!!this.state.sortingColumnId && !!this.state.sort_order) {
      data = this.dataSort(data, this.state.sortingColumnId, this.state.sort_order);
    } else {
      const stationNameCol = template.columns.find(item => item.type === 2 && item.key === -1);
      const dateCol = template.columns.find(item => item.type === 6);

      if (stationNameCol && dateCol)
        data.sort((a, b) => a[stationNameCol.label].localeCompare(b[stationNameCol.label]) || b[dateCol.label].localeCompare(a[dateCol.label]));
      else if (stationNameCol)
        data.sort((a, b) => a[stationNameCol.label].localeCompare(b[stationNameCol.label]));
      else if (dateCol)
        data.sort((a, b) => b[dateCol.label].localeCompare(a[dateCol.label]));
    }

    let snCol = columns.find(item => item.type === 1);
    if (!!snCol) {
      data = data.map((item, index) => ({ ...item, [snCol.label]: index + 1 }));
    }

    return <DataTable
      data={data}
      sortRow={rows => rows}
      columns={columns} slug='/export/export' />
  }

  _renderLocationFilterIinputs = () => {
    const { locationStore, locationTypeStore } = this.props;
    return (
      <div>
        <SelectInput label='Location Type' value={this.filters.location_type_id}
          options={locationTypeStore.items}
          onChange={e => this.onChangeFilters('location_type_id', e)} fields={{ label: 'name', value: 'id' }} />
        <SelectInput label='Location' value={this.filters.location_id}
          options={locationStore.items.filter(item => item.type_id === this.filters.location_type_id)}
          onChange={e => this.onChangeFilters('location_id', e)} fields={{ label: 'name', value: 'id' }}
        />
      </div>
    )
  }

  getChartSvg = (raw_observations, report_observations) => {
    let hiddenImage = document.createElement('a');
    document.body.appendChild(hiddenImage);
    let series = [], tempSeries = {};
    Object.keys(report_observations).forEach(date => {
      Object.keys(report_observations[date]).forEach(station => {
        let rawStation = raw_observations.find(item => +item.id === +station.replace('station_', ''));
        if (!!rawStation) {
          Object.keys(report_observations[date][station]).forEach(parameter => {
            let path = [rawStation.name, parameter, date];
            _.set(tempSeries, path, report_observations[date][station][parameter]);
          })
        }
      })
    })

    Object.keys(tempSeries).forEach(station => {
      Object.keys(tempSeries[station]).forEach(parameter => {
        series.push({
          name: `${station} - ${parameter}`,
          type: ['sum', 'accumulated', 'total'].reduce((acc, item) => acc || parameter.toLowerCase().indexOf(item) > -1, false) ? 'column' : 'line',
          data: Object.keys(tempSeries[station][parameter]).map(date => [getDisplayDate(date, { returnMills: true }), tempSeries[station][parameter][date]])
        })
      })
    })

    if (series.length == 0) return null;

    const chart = {
      chart: {
        zoomType: 'x',
      },
      title: {
        text: '',
      },
      xAxis: {
        type: 'datetime',
      },
      yAxis: {
        title: {
          text: this.state.unit,
        },
      },
      series,
      // series: _.flatten(observations.map(station => !station.parameters || !station.parameters.length ? [] : station.parameters.map(parameter => {
      //   return {
      //     name: `${station.name} - ${parameter.name}`,
      //     data: parameter.data.map(item => [getDisplayDate(item.time, { returnMills: true }), item.value]),
      //     type: parameter.parameter_property === 'Accumulative' ? 'column' : 'line',
      //   }
      // }))),
    };


    // return fetch('https://export.highcharts.com', {
    return fetch(`${BASE_URL}/highcharts`, {
      method: 'post',
      body: JSON.stringify({
        infile: chart,
        b64: true
      }),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(res => res.text());
  }

  render() {
    const { stationStore, reportingTemplateStore } = this.props;
    const { date_from, date_to, report_template_id, latest, filter_by_location } = this.filters;

    const selectedReportTemplate = reportingTemplateStore.items.find(
      item => item.id == report_template_id
    );
    const columns = selectedReportTemplate ? selectedReportTemplate.columns : [];

    return (
      <div>
        <Form>
          <FormBody>
            <SwitchInput label='Filter By Location' value={filter_by_location} onChange={() => this.onChangeFilters('filter_by_location', { target: { value: !filter_by_location } })} />
            {!filter_by_location && <FormMultiSelectInput id='station-multi-select' label='Stations' options={this.multiStationOptions} optionClicked={this.onOptionClicked} isLoading={stationStore.isLoading} filterOptions={stationStore.filterStations} />}
            {filter_by_location && this._renderLocationFilterIinputs()}
            <SelectInput label='Report Template' value={report_template_id} options={reportingTemplateStore.items} fields={{ label: 'name', value: 'id' }} onChange={e => this.onChangeFilters('report_template_id', e)} />
            {/* <SwitchInput label='Latest' value={latest} onChange={() => this.onChangeFilters('latest', { target: { value: !latest } })} /> */}
            {!latest && <DateInput type={'datetime-local'} label={'Date From'} value={date_from} onChange={e => this.onChangeFilters('date_from', e)} />}
            {!latest && <DateInput type={'datetime-local'} label={'Date To'} value={date_to} onChange={e => this.onChangeFilters('date_to', e)} />}
            <div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <SelectInput label='Sort By' value={this.state.sortingColumnId} options={columns.map(column => ({ label: column.label, value: column.id }))} fields={{ label: 'label', value: 'value' }} onChange={this.handleSortingColumnChange} />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <button style={{ padding: '0px', margin: "0", background: "white" }} onClick={(e) => this.handleSortOrderChange(e, 'asc')}><i className='fa fa-caret-up' /> </button>
                  <button style={{ padding: '0px', margin: "0", background: "white" }} onClick={(e) => this.handleSortOrderChange(e, 'desc')}><i className='fa fa-caret-down' /></button></div>
              </div> </div>
            <SwitchInput label='Include Graph' value={this.includeGraph} onChange={() => this.includeGraph = !this.includeGraph} />
            <SwitchInput label='Split by Station' value={this.splitByStation} onChange={() => this.splitByStation = !this.splitByStation} />
          </FormBody>
          <FormActions>
            <button onClick={this.onView}>View</button>
            {this.report !== '' && <button onClick={this.onDownload}>Download</button>}
            {!this.includeGraph && <button onClick={this.sendMail}>Send to Mail</button>}
          </FormActions>
        </Form>
        {this.isLoading && <Spinner />}
        {this.report !== '' && this._renderReport(this.report)}
      </div>
    )
  }

}

export default ReportGenerate;


// WEBPACK FOOTER //
// ./src/components/DataDelivery/ReportingTemplate/ReportGenerate.js